// Asset URLs (landing page imagery)

// About section main image (farmer scattering urea in paddy field)
export const IMG_ABOUT_MAIN = "https://customer-assets.emergentagent.com/job_smart-urea/artifacts/2ckqdl3h_image.png";

// About + Why Choose Us collage
export const IMG_FARMER_FIELD = "https://customer-assets.emergentagent.com/job_0b72a1b5-bf3c-4186-8127-7ba5f473fb64/artifacts/kn7o81c2_image.png";
export const IMG_TWO_FARMERS = "https://customer-assets.emergentagent.com/job_0b72a1b5-bf3c-4186-8127-7ba5f473fb64/artifacts/tyxcvxlu_image.png";
export const IMG_UREA_HAND = "https://customer-assets.emergentagent.com/job_0b72a1b5-bf3c-4186-8127-7ba5f473fb64/artifacts/brh0huiv_image.png";
export const IMG_UREA_GLOVE = "https://customer-assets.emergentagent.com/job_0b72a1b5-bf3c-4186-8127-7ba5f473fb64/artifacts/f5xqv8t2_image.png";
export const IMG_FARMER_RUN = "https://customer-assets.emergentagent.com/job_0b72a1b5-bf3c-4186-8127-7ba5f473fb64/artifacts/6gitg3jd_image.png";

// Hero slider images
export const HERO_UREA_TRACTOR  = "https://customer-assets.emergentagent.com/job_smart-urea/artifacts/oet2z3l9_image.png";
export const HERO_3_FARMERS     = "https://customer-assets.emergentagent.com/job_smart-urea/artifacts/nfdy86e6_image.png";
export const HERO_SUNSET_WOMAN  = "https://customer-assets.emergentagent.com/job_smart-urea/artifacts/ir08nt8g_image.png";
export const HERO_LONE_SOWER    = "https://customer-assets.emergentagent.com/job_smart-urea/artifacts/zncl8o40_image.png";
